

























































































import { Component, Prop, Vue } from "vue-property-decorator";
import MainButton from "@/main-components/common/MainButton.vue";
import { SuggestedJob } from "./suggested-job.type";

@Component({
  components: { MainButton },
})
export default class SuggestedJobView extends Vue {
  @Prop({ default: false })
  isHidden: boolean;

  @Prop({ default: false })
  isFullAccess: boolean;

  @Prop({ required: true })
  suggestedJob: SuggestedJob;

  unlockJobClick() {
    this.$sendMpEvent({
      event: this.$mp_value.CareerPath_unlock_more,
    });

    this.$emit("openUnlockCareerModal", true);
    // window.open("https://wa.me/601159951420?text=Unlock Pekerjaan", "_blank");˝
  }

  unlockSalaryClick() {
    this.$sendMpEvent({
      event: this.$mp_value.CareerPath_unlock_salary,
    });

    this.$emit("openUnlockCareerModal", false);
  }
}
